import { render } from "./ModalCommands.vue?vue&type=template&id=74946880"
import script from "./ModalCommands.vue?vue&type=script&lang=js"
export * from "./ModalCommands.vue?vue&type=script&lang=js"

import "./ModalCommands.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__